<div class="container">
     <p style="color: var(--text-description)">{{dataItem}}</p>
</div>

